import React from "react";
import styled from "styled-components";
import preface1 from '../../images/cardesign/preface1.jpg'
;


const ArticleWrapper = styled.div`
  max-width: 800px;
  margin: auto;
  padding: 2rem;
  overflow-y: auto;
`;

const Img = styled.img`
  width: 100%;
  margin: 1rem 0;
`;

 const PrefaceChapter=()=> (

<ArticleWrapper>

<h2>Preface Chapter</h2>
<p>This page is under construction. 🚧</p>

 <Img src={preface1} alt="Airbag Sensor Diagram" />
  
</ArticleWrapper>

 )

 export default PrefaceChapter
  
